import I18n from '@/rI18n';
import * as yup from 'yup';
import Schema from '@/schema/Schema';
import BaseCustomSchema from './BaseCustomSchema';

const CreateTicketQAInChatbotSchema = (fieldListData, validationMessages = {}) => {
    let validateObj = {};

    if (fieldListData) {
        validateObj = BaseCustomSchema(fieldListData);
    }

    // Helper function to get validation message
    const getMsg = (key, variables = {}) => {
        let validateMsg = validationMessages[key];
        if (validateMsg) {
            return validateMsg;
        }

        // Fallback mapping - match exactly with old code
        const fallbackMessages = {
            'form_invalid_msg_required': 'COMMSG014',
            'form_invalid_msg_email_invalid': 'COMM01MSG07',
            'form_invalid_msg_email_max_length': 'COMMSG022',
            'form_invalid_msg_email_confirm_mismatch': 'COMMSG036',
            'form_invalid_msg_name_max_length': 'COMMSG022'
        };

        const localeKey = fallbackMessages[key] || 'COMMSG014';
        let message = I18n.get(localeKey);

        // Replace variables if any
        if (variables.maxLength) {
            message = message.replace('{{maxLength}}', variables.maxLength);
        }

        return message;
    };

    validateObj[`mailAddress`] = yup
        .string()
        .required(getMsg('form_invalid_msg_required'))
        .email(getMsg('form_invalid_msg_email_invalid'))
        .max(200, getMsg('form_invalid_msg_email_max_length', { maxLength: '200' }))
        .trim();

    validateObj[`reEmailAddress`] = yup
        .string()
        .required(getMsg('form_invalid_msg_required'))
        .email(getMsg('form_invalid_msg_email_invalid'))
        .oneOf([Schema.ref('mailAddress'), null], getMsg('form_invalid_msg_email_confirm_mismatch'))
        .max(200, getMsg('form_invalid_msg_email_max_length', { maxLength: '200' }))
        .trim();

    validateObj[`lastName`] = yup
        .string()
        .max(128, getMsg('form_invalid_msg_name_max_length', { maxLength: '128' }))
        .trim();

    validateObj[`firstName`] = yup
        .string()
        .max(128, getMsg('form_invalid_msg_name_max_length', { maxLength: '128' }))
        .trim();

    validateObj[`lastNameKana`] = yup
        .string()
        .max(128, getMsg('form_invalid_msg_name_max_length', { maxLength: '128' }))
        .trim();

    validateObj[`firstNameKana`] = yup
        .string()
        .max(128, getMsg('form_invalid_msg_name_max_length', { maxLength: '128' }))
        .trim();

    validateObj[`formSelected`] = yup.string().required(getMsg('form_invalid_msg_required'));

    return Schema.object().shape(validateObj);
};

export default CreateTicketQAInChatbotSchema;
